// extracted by mini-css-extract-plugin
export default {"container":"YT-z","topReviewHeading":"ZT-z","criticalReview":"_T-z","favorableReview":"aU-z","vsSeparator":"bU-z"};